export const createDoc = (doc:any) => {
    return {
        ...doc.data(),
        db_id: doc.id
    }
}

export default createDoc